import { createAction } from '@reduxjs/toolkit'

import { IResponseError } from '@lib/error'

export const copyCampaign = createAction(
  'campaign/COPY_CAMPAIGN',
  (campaignId: number, onSuccess?: () => void, successMessage?: string) => ({
    payload: {
      campaignId,
      onSuccess,
      successMessage,
    },
  }),
)

export const copyCampaignSuccess = createAction(
  'campaign/COPY_CAMPAIGN_SUCCESS',
  (campaignId: number) => ({
    payload: {
      campaignId,
    },
  }),
)

export const copyCampaignError = createAction(
  'campaign/COPY_CAMPAIGN_ERROR',
  (campaignId: number, error: IResponseError) => ({
    payload: {
      campaignId,
      error,
    },
  }),
)
